import { render, staticRenderFns } from "./Form01_134.vue?vue&type=template&id=28fe61f2&scoped=true&"
import script from "./Form01_134.vue?vue&type=script&lang=js&"
export * from "./Form01_134.vue?vue&type=script&lang=js&"
import style0 from "./Form01_134.vue?vue&type=style&index=0&id=28fe61f2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28fe61f2",
  null
  
)

export default component.exports